import { render } from "./teacher.vue?vue&type=template&id=7c6cee70&scoped=true"
import script from "./teacher.vue?vue&type=script&lang=js"
export * from "./teacher.vue?vue&type=script&lang=js"

import "./teacher.vue?vue&type=style&index=0&id=7c6cee70&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6cee70"]])

export default __exports__